import pluralize from "pluralize";
import { type ComponentPropsWithoutRef, useMemo } from "react";
import type { Tooltip } from "recharts";
import { formatDateToUTC } from "./util";

export function MetricTooltip({
  active,
  payload,
  label,
  unit,
}: ComponentPropsWithoutRef<typeof Tooltip> & { unit?: string }) {
  if (active && payload && payload.length) {
    const num = Number(payload[0].value);

    const formattedDateLabel = useMemo(() => {
      if (!label) return null;
      return formatDateToUTC(label);
    }, [label]);

    if (!formattedDateLabel) return null;

    return (
      <div className="max-w-[12rem] border border-black bg-white px-2 pb-2 pt-1">
        <span className="text-r8-gray-11 text-xs">{formattedDateLabel}</span>
        <p className="text-xs">
          {num} {unit ? pluralize(unit, num) : null}
        </p>
      </div>
    );
  }

  return null;
}
